import request from '@/utils/request'

// ==================== 实时态势 ====================
export const getDashboardOverview = (region) => request.get('/dashboard/overview', { params: region ? { region } : {} })
export const getDashboardTrend = (region) => request.get('/dashboard/trend', { params: region ? { region } : {} })
export const getDashboardStations = (region) => request.get('/dashboard/stations', { params: region ? { region } : {} })
export const getDashboardAlerts = (region) => request.get('/dashboard/alerts', { params: region ? { region } : {} })

// ==================== 设备与站点 ====================
export const getDevices = (params) => request.get('/devices/page', { params })
export const getAllDevices = () => request.get('/devices')
export const getDevice = (id) => request.get(`/devices/${id}`)
export const createDevice = (data) => request.post('/devices', data)
export const updateDevice = (id, data) => request.put(`/devices/${id}`, data)
export const deleteDevice = (id) => request.delete(`/devices/${id}`)
export const reportDevice = (code) => request.post('/devices/report', { code })

export const getStations = () => request.get('/stations')
export const getStation = (id) => request.get(`/stations/${id}`)
export const createStation = (data) => request.post('/stations', data)
export const updateStation = (id, data) => request.put(`/stations/${id}`, data)
export const deleteStation = (id) => request.delete(`/stations/${id}`)

// ==================== 历史数据 ====================
export const getObservations = (params) => request.get('/observations', { params })
export const getAllObservations = () => request.get('/observations/all')
export const getObservation = (id) => request.get(`/observations/${id}`)
export const createObservation = (data) => request.post('/observations', data)
export const updateObservation = (id, data) => request.put(`/observations/${id}`, data)
export const deleteObservation = (id) => request.delete(`/observations/${id}`)
export const getObservationTrend = (params) => request.get('/observations/trend', { params })

// ==================== 预警中心 ====================
export const getAlertRules = () => request.get('/alerts/rules')
export const getAlertRule = (id) => request.get(`/alerts/rules/${id}`)
export const createAlertRule = (data) => request.post('/alerts/rules', data)
export const updateAlertRule = (id, data) => request.put(`/alerts/rules/${id}`, data)
export const deleteAlertRule = (id) => request.delete(`/alerts/rules/${id}`)

export const getAlertEvents = (params) => request.get('/alerts/events', { params })
export const getAlertEvent = (id) => request.get(`/alerts/events/${id}`)
export const createAlertEvent = (data) => request.post('/alerts/events', data)
export const deleteAlertEvent = (id) => request.delete(`/alerts/events/${id}`)
export const handleAlertEvent = (id, data) => request.post(`/alerts/events/${id}/handle`, data)
export const getAlertStats = (region) => request.get('/alerts/stats', { params: region ? { region } : {} })

// ==================== 报表中心 ====================
export const getReportTemplates = () => request.get('/reports/templates')
export const createReportTemplate = (data) => request.post('/reports/templates', data)
export const updateReportTemplate = (id, data) => request.put(`/reports/templates/${id}`, data)
export const deleteReportTemplate = (id) => request.delete(`/reports/templates/${id}`)

export const getReportTasks = () => request.get('/reports/tasks')
export const createReportTask = (data) => request.post('/reports/tasks', data)
export const updateReportTask = (id, data) => request.put(`/reports/tasks/${id}`, data)
export const deleteReportTask = (id) => request.delete(`/reports/tasks/${id}`)

// ==================== 系统管理 ====================
export const getOrganizations = () => request.get('/system/organizations')
export const createOrganization = (data) => request.post('/system/organizations', data)
export const updateOrganization = (id, data) => request.put(`/system/organizations/${id}`, data)
export const deleteOrganization = (id) => request.delete(`/system/organizations/${id}`)

export const getUsers = () => request.get('/system/users')
export const createUser = (data) => request.post('/system/users', data)
export const updateUser = (id, data) => request.put(`/system/users/${id}`, data)
export const deleteUser = (id) => request.delete(`/system/users/${id}`)
export const loginUser = (data) => request.post('/system/login', data)
export const registerUser = (data) => request.post('/system/register', data)
export const applyRoleChange = (data) => request.post('/system/role-change-request', data)
// 管理员审批身份变更申请
export const getRoleChangeRequests = () => request.get('/system/role-change-requests')
export const approveRoleChange = (id) => request.post(`/system/role-change-requests/${id}/approve`)
export const rejectRoleChange = (id) => request.post(`/system/role-change-requests/${id}/reject`)

export const getRoles = () => request.get('/system/roles')
export const createRole = (data) => request.post('/system/roles', data)
export const updateRole = (id, data) => request.put(`/system/roles/${id}`, data)
export const deleteRole = (id) => request.delete(`/system/roles/${id}`)

export const getPermissions = () => request.get('/system/permissions')
export const createPermission = (data) => request.post('/system/permissions', data)
export const updatePermission = (id, data) => request.put(`/system/permissions/${id}`, data)
export const deletePermission = (id) => request.delete(`/system/permissions/${id}`)

export const getCategories = () => request.get('/system/categories')
export const createCategory = (data) => request.post('/system/categories', data)
export const updateCategory = (id, data) => request.put(`/system/categories/${id}`, data)
export const deleteCategory = (id) => request.delete(`/system/categories/${id}`)

export const getAuditLogs = () => request.get('/system/audit-logs')
export const createAuditLog = (data) => request.post('/system/audit-logs', data)

// ==================== 回收站 ====================
export const getRecycleDevices = () => request.get('/recycle/devices')
export const getRecycleStations = () => request.get('/recycle/stations')
export const getRecycleObservations = () => request.get('/recycle/observations')
export const getRecycleAlertRules = () => request.get('/recycle/alert-rules')
export const getRecycleAlertEvents = () => request.get('/recycle/alert-events')
export const getRecycleReportTasks = () => request.get('/recycle/report-tasks')

// 恢复接口（复用各模块已有的 restore 端点）
export const restoreDevice = (id) => request.post(`/devices/${id}/restore`)
export const restoreStation = (id) => request.post(`/stations/${id}/restore`)
export const restoreObservation = (id) => request.post(`/observations/${id}/restore`)
export const restoreAlertRule = (id) => request.post(`/alerts/rules/${id}/restore`)
export const restoreAlertEvent = (id) => request.post(`/alerts/events/${id}/restore`)
export const restoreReportTask = (id) => request.post(`/reports/tasks/${id}/restore`)

// ---------- 回收站清理（定期清理 / 手工清理 / 彻底删除）----------
export const getRecycleConfig = () => request.get('/recycle/config')
export const getRecycleStats = (days) => request.get('/recycle/stats', { params: { days } })
export const getRecycleModules = () => request.get('/recycle/modules')
// days 不传=按配置保留期；传 0 = 无视保留期全清
export const runRecycleCleanup = (days, operator) =>
  request.post('/recycle/cleanup', null, { params: { days, operator } })
export const purgeRecycleModule = (module, days, operator) =>
  request.delete(`/recycle/${module}`, { params: { days, operator } })
export const purgeRecycleOne = (module, id, operator) =>
  request.delete(`/recycle/${module}/${id}`, { params: { operator } })
